export default class InvalidForecastError extends Error {
    constructor(){
        super("La oportunidad no esta en Forecast");
        this.type = "InvalidForecastError";
        this.info = "La oportunidad debe estar en Forecast para poder crear facturas";
    }
}